import { render, staticRenderFns } from "./CommonTableContainer.vue?vue&type=template&id=0af7daab&scoped=true"
import script from "./CommonTableContainer.vue?vue&type=script&lang=js"
export * from "./CommonTableContainer.vue?vue&type=script&lang=js"
import style0 from "./CommonTableContainer.vue?vue&type=style&index=0&id=0af7daab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af7daab",
  null
  
)

export default component.exports